<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加用户"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="userInfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="userInfo.name" placeholder="请输入用户名">
        </Input>
      </FormItem>
      <FormItem prop="nickName">
        <Input v-model="userInfo.nickName" placeholder="请输入昵称">
        </Input>
      </FormItem>
      <FormItem prop="realName">
        <Input v-model="userInfo.realName" placeholder="请输入真实姓名">
        </Input>
      </FormItem>
      <FormItem prop="sex">
        <Select v-model="userInfo.sex" style="width:200px">
          <Option v-for="item in userSex" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="mobilePhoneNum">
        <Input v-model="userInfo.mobilePhoneNum" placeholder="请输入手机号码">
        </Input>
      </FormItem>
      <FormItem prop="introduction">
        <Input type="textarea" v-model="userInfo.introduction" placeholder="请输入简介">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'AddUserModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '用户名不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        userSex:[
          {label:'女',value:0},
          {label:'男',value:1},
          {label:'未知',value:2},
          ],
        userInfo: {
          name:null,
          nickName:null,
          realName:null,
          sex:2,
          mobilePhoneNum:null,
          introduction:null
        }
      }
    },
    methods: {
      ...mapActions([
        'UserServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加用户',
          content: '<p>是否确认添加用户</p>',
          onOk: () => {
            store.dispatch('UserServ_AddObj', {params: this.userInfo}).then(() => {
              this.$Message.success('添加用户成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.userInfo.name = null
          this.userInfo.nickName = null
          this.userInfo.realName = null
          this.userInfo.sex = 2
          this.userInfo.mobilePhoneNum = null
          this.userInfo.introduction = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
